<template>
    <project-step-container
            cover-page
            prev-to="be_edit_project"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <div class="content-cover">
            <div class="content-cover-item first-form-initial-1">
                <div class="content-cover-item-header">
                    <div class="heart-icon"/>
                </div>
                <div class="content-cover-item-body">
                    <p class="content-cover-item-body-title text-uppercase" tabindex="0">{{getMessage(2, 'empathy-map-title')}} </p>
                    <p class="content-cover-item-body-description" tabindex="0">
                        {{getMessage(2, 'empathy-map-sub')}}
                    </p>
                </div>
                <div class="content-cover-item-footer waves-icon"></div>
            </div>
            <div class="content-cover-item content-guide">
                <LinkStyleGuide class="guide-text" @open-url="openGuide" :is-box-shadow="false"
                        icon-name="icon-guide" :text="getMessage(2, 'empathy-map-guide')" />
            </div>
        </div>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import {ConflictSyn, Project, StyleGuides} from '../../../core/Utils'
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {Steps} from "@/modules/BeEntrepreneurship/Utils";

    export default {
        name: "DeepCustomerEmpathy2",
        components: {ProjectStepContainer ,ProjectStyleGuide, LinkStyleGuide} ,
         data() {
            return {
                step:Steps.FORM_DEEP_CUSTOMER_EMPATHY,
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.DEEP_CUSTOMER_EMPATHY_GUIDE),
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'be_deep_customer_empathy_3', params: {index}})
            }
        }
    }

</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .content-cover-item-body-title
        color black
    .content-cover-item-body-description
        color black  
    .content-cover-item-body
        margin-top  -25px
    .subtitle
        font font-sourcesans-bold
        font-size 14px

    .heart-icon
        background url("../../D4D/Images/empathy_heart.svg")
        height 89px
        width 223px
        background-repeat no-repeat

    .waves-icon
        background url("../../D4D/Images/waves.svg")
        height 68px
        width 100%
        opacity 0.5
        border-radius 0 0 27px 27px
</style>
